import {Breadcrumb} from "antd";
import React, {useContext} from "react";
import {AppContextContext} from "../../Contexts";
import {DocumentTitle} from "../DocumentTitle";
import * as globalStyles from "../App.module.css";
import SourceUpdatesOverview from "./SourceUpdatesOverview";

function SourceUpdatesPage() {
    const appContext = useContext(AppContextContext);
    const title = "Source updates";

    return (
        <DocumentTitle title={title}>
            <>
                <Breadcrumb className={globalStyles["common__breadcrumb"]}
                            items={[
                                {title: appContext.config?.appName},
                                {title}
                            ]}
                />

                <h1>{title}</h1>

                <SourceUpdatesOverview/>
            </>
        </DocumentTitle>
    );
}

export default SourceUpdatesPage;
